import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './Row.module.less'
import Icon from '../Icon'

export default class Row extends Component {
  state = {
    active: false
  }

  clickHandle () {
    if (this.props.disabled) {
      return false
    }
    this.props.clickHandle()
    this.setState({ active: true })
    setTimeout(() => {
      this.setState({ active: false })
    }, 100)
  }

  render () {
    const rowClass = [style.row]
    if (this.state.active) {
      rowClass.push(style.active)
    }
    if (this.props.disabled) {
      rowClass.push(style.disabled)
    }
    const d = this.props.data
    return (
      <div className={rowClass.join(' ')} onClick={() => this.clickHandle()}>
        <div className={style['row-inner']}>
          <div className={style['text-block']}>
            <div className={style.title}>{d.name}</div>
            <div className={style['sub-title']}>{d.structure}</div>
          </div>
          <div className={style.arrow}>
            <Icon name='arrow-right' />
          </div>
        </div>
      </div>
    )
  }
}

Row.propTypes = {
  data: PropTypes.object,
  clickHandle: PropTypes.func,
  disabled: PropTypes.bool
}

Row.defaultProps = {
  data: null,
  clickHandle: () => {},
  disabled: false
}
